<template>
  <div class="c-emo-well">
    <img :src="wellImgUrl" alt="xxxxxxxxxxxx">
    <br/>
    <div class="c-fs-14" v-bind:style="{color: returnTextClasses}"><b>{{wellMsg}}</b></div>
  </div>
</template>

<script>
export default {
  name: 'EmoWellComp',
  props: ['inputWellType', 'inputTxtMsg', 'inputTxtColor'],
  data () {
    return {
      wellType: 'basic',
      wellMsg: 'This is dummy message for well',
      wellImgUrl: require('@/assets/img/lndresapp-emo-no-content.png')
    }
  },
  computed: {
    returnTextClasses: function () {
      var returnValue = '';
      if (this.inputTxtColor){
        returnValue = this.inputTxtColor;
      }
      return returnValue;
    }
  },
  methods: {
    // ~ class for type of well (basic, info, success..)
    prepareWellContent: function (inputWellType, inputTxtMsg) {
      if (inputWellType && inputTxtMsg) {
        switch (inputWellType) {
          case 'no-content':
            this.wellType = 'no-content';
            this.wellImgUrl = require('@/assets/img/lndresapp-emo-no-content.png');
            this.wellMsg = inputTxtMsg;
            break
          case 'forbidden':
            this.wellType = 'forbidden';
            this.wellImgUrl = require('@/assets/img/lndresapp-emo-forbidden.png');
            this.wellMsg = inputTxtMsg;
            break
          case 'doubt':
            this.wellType = 'doubt';
            this.wellImgUrl = require('@/assets/img/lndresapp-emo-doubt.png');
            this.wellMsg = inputTxtMsg;
            break
        }
      }
    }
  },
  created () {
    this.prepareWellContent(this.inputWellType, this.inputTxtMsg)
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/wells/EmoWellComp.vue